import React from 'react';
import PropTypes from 'prop-types';

/**
 * OAuthLoadingStep — Loading spinner shown while redirecting to OAuth provider.
 *
 * This is briefly visible before the browser navigates away to the provider.
 *
 * @param {Object} props
 * @param {string} props.platform - 'twitch' or 'google'
 * @returns {JSX.Element}
 */
function OAuthLoadingStep({ platform }) {
  const platformName = platform === 'twitch' ? 'Twitch' : 'Google';

  return (
    <div className="auth-step oauth-loading-step">
      <div className="oauth-loading-step__spinner" />
      <h2 className="auth-step__title">Connecting to {platformName}...</h2>
      <p className="auth-step__subtitle">Please wait while we verify your account</p>
    </div>
  );
}

OAuthLoadingStep.propTypes = {
  platform: PropTypes.oneOf(['twitch', 'google']),
};

export default OAuthLoadingStep;
